export default __webpack_public_path__ + "static/media/img-otros-plan.ac1256a0.png";